import { Link } from "react-router-dom";
import { Smartphone, CreditCard, BookUser, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { IMG } from "@/config/site";
import { SectionHead, Reveal, StatusChip } from "@/components/common";

export function EcosystemSection({ compact = false }) {
  const { t } = useLang();
  const items = [
    {
      icon: Smartphone, img: IMG.phone, title: t("eco.appT"), desc: t("eco.appD"),
      cta: t("eco.appCta"), status: "in_progress", statusLabel: t("common.inDevelopment"), to: "/ecosystem", id: "app",
    },
    {
      icon: CreditCard, img: IMG.blackCard, title: t("eco.cardT"), desc: t("eco.cardD"),
      cta: t("eco.cardCta"), status: "planned", statusLabel: t("common.concept"), to: "/ecosystem", id: "card",
    },
    {
      icon: BookUser, img: IMG.passport, title: t("eco.passT"), desc: t("eco.passD"),
      cta: t("eco.passCta"), status: "in_progress", statusLabel: t("common.inDevelopment"), to: "/mint", id: "passport",
    },
  ];
  return (
    <section className="section-pad py-24" data-testid="ecosystem-section">
      {!compact && <SectionHead eyebrow={t("eco.eyebrow")} title={t("eco.title")} />}
      <div className={`grid gap-6 lg:grid-cols-3 ${compact ? "" : "mt-12"}`}>
        {items.map((it, i) => (
          <Reveal key={it.id} delay={i * 0.1}>
            <div className="card-surface group h-full overflow-hidden" data-testid={`eco-${it.id}`}>
              <div className="relative h-52 overflow-hidden">
                <img src={it.img} alt={it.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-panel via-panel/30 to-transparent" />
                <div className="absolute left-4 top-4"><StatusChip status={it.status} label={it.statusLabel} /></div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3">
                  <it.icon size={20} className="text-goldlight" />
                  <h3 className="font-heading text-xl font-bold uppercase tracking-wide text-paper">{it.title}</h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-mist">{it.desc}</p>
                <Link to={it.to} data-testid={`eco-cta-${it.id}`}
                  className="mt-5 inline-flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-[0.2em] text-neon transition-colors hover:text-goldlight">
                  {it.cta} <ArrowUpRight size={14} />
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
